/**
 * Cart drawer "Perfect to match with" carousel.
 * Native scroll-snap track + prev/next arrows. Implemented as a custom element
 * so it re-initialises on its own every time the drawer contents are replaced
 * via innerHTML after a cart update.
 */
if (!customElements.get('bb-cart-complement-carousel')) {
  customElements.define(
    'bb-cart-complement-carousel',
    class BbCartComplementCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-complement-track]');
        this.prevButton = this.querySelector('[data-complement-prev]');
        this.nextButton = this.querySelector('[data-complement-next]');
        if (!this.track || !this.prevButton || !this.nextButton) return;

        this.update = this.update.bind(this);
        this.onPrev = () => this.go(-1);
        this.onNext = () => this.go(1);

        this.prevButton.addEventListener('click', this.onPrev);
        this.nextButton.addEventListener('click', this.onNext);
        this.track.addEventListener('scroll', this.update, { passive: true });

        // The drawer is hidden (zero width) until opened, so re-check on resize.
        this.resizeObserver = new ResizeObserver(this.update);
        this.resizeObserver.observe(this.track);

        this.update();
      }

      disconnectedCallback() {
        if (!this.track) return;
        this.prevButton.removeEventListener('click', this.onPrev);
        this.nextButton.removeEventListener('click', this.onNext);
        this.track.removeEventListener('scroll', this.update);
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      get isRtl() {
        return getComputedStyle(this.track).direction === 'rtl';
      }

      get step() {
        const slide = this.track.firstElementChild;
        if (!slide) return this.track.clientWidth;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return slide.getBoundingClientRect().width + gap;
      }

      go(direction) {
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollBy({
          left: direction * this.step * (this.isRtl ? -1 : 1),
          behavior: reduceMotion ? 'auto' : 'smooth',
        });
      }

      update() {
        // scrollLeft is negative in RTL, so compare absolute offsets.
        const position = Math.abs(this.track.scrollLeft);
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.prevButton.disabled = position <= 1;
        this.nextButton.disabled = position >= max - 1;
      }
    }
  );
}
